import { LS } from 'ls-ts';

import { ProfileResponse, TokenResponse, userService } from '#/client';
import { StorageKeys } from '#/service/constants';
import { getDeviceInfo } from '#/service/user/userSessionManager';

export async function getAnonymousToken() {
  const reqBody = {
    deviceInfo: getDeviceInfo(),
  };

  await userService.getAnonymousToken(reqBody);
}

interface AuthTokenLs extends Omit<TokenResponse, 'token' | 'refreshToken'> {
  isLoggedIn: boolean;
}

export function saveAuthToken(tokenResponse: TokenResponse) {
  const { token, refreshToken, ...rest } = tokenResponse;

  const lsToken: AuthTokenLs = {
    isLoggedIn: Boolean(token && refreshToken),
    ...rest,
  };

  LS.write(StorageKeys.AUTHENTICATION, lsToken);
}

// Slack discussion: https://accedo.slack.com/archives/CLG74PZHD/p1701268561275589
// HMN is obviously HMN-specific and we can ignore it in our detection logic
// Toast - I still don't know what it is, but it's applicable to the new accounts only
// and again - we can ignore it
const ignoredSubscriptionIds = ['HMN', 'Toast'];

/**
 * Logic for guessing if subscription is Web-based and as-such it can be managed
 * through the Web client
 * */
export function canManageSubscription(profile: ProfileResponse) {
  if (!profile.entitlements?.subscriber) {
    return false;
  }

  const subscriptions = (profile.entitlements.subscriptions ?? []).filter(
    ({ id }) => !ignoredSubscriptionIds.includes(id)
  );

  return subscriptions.some(
    ({ purchaseMethod }) => purchaseMethod === 'CREDIT_CARD'
  );
}
